import { productCarouselProductFullStyles } from "@insite/content-library/Components/ProductCarouselProductFull";
import { css } from "styled-components";

productCarouselProductFullStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            justify-content: center;
            width: auto;
        `,
    },
}